import { ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class IssuerType extends ModelBase {
    static typeName = "IssuerType";

    public issuerTypeId: number = 0;

    @Rules.StringLength(50)
    @Rules.Required()
    public issuerTypeName: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.issuerTypeName) {
            return "New issuer type";
        } else {
            return this.issuerTypeName;
        }
    }
}